import styles from './styles.module.scss';

import React from 'react';
import { Board } from '../Board';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    content: string;
    showModal: React.ComponentState;
    onPress: React.MouseEventHandler<HTMLDivElement>;
    children?: any;
}

export const Modal = ({ content,children, showModal, onPress }: Props) => {
    return (
        <div data-open={showModal} className={styles.wrapper}>
            <div className={styles.wrapperInner}>
                <Board wrapperClass={styles.board}>

                    <div className={styles.boardInner}>
                    {children}
                        <div
                            className={styles.content}
                            dangerouslySetInnerHTML={{__html: content }}
                        ></div>
                        <div className={styles.button} onClick={onPress}>
                            <div className={`fa fa-check`} />
                        </div>
                    </div>
                </Board>
            </div>
        </div>
    );
};
